import { combineReducers } from 'redux';
//import { LOCATION_CHANGE } from 'react-router-redux';
//import pathToRegexp from 'path-to-regexp';
import * as ActionTypes from './content.actionTypes';
import merge from 'lodash/merge';

const allIds = (state = [], action) => {
  switch (action.type) {
    case ActionTypes.READ_CONTENT_SUCCESS: {
      const newEntryIndex = state.indexOf(action.response.result);
      if (newEntryIndex > -1) {
        return state;
      }
      return [...state, action.response.result];
    }
    case ActionTypes.READ_CONTENTS_SUCCESS:
      return action.response.result;
    default:
      return state;
  }
};

const byId = (state = {}, action) => {
  if (
    action.response &&
    action.response.entities &&
    action.response.entities.content
  ) {
    return merge({}, state, action.response.entities.content);
  }
  return state;
};

const updated = (state = { timestamp: null }, action) => {
  if (
    action.type === ActionTypes.READ_CONTENT_FAILURE ||
    (action.response &&
      action.response.entities &&
      action.response.entities.content)
  ) {
    return {
      ...state,
      timestamp: new Date().getTime(),
    };
  }
  return state;
};

const loading = (state = false, action) => {
  switch (action.type) {
    case ActionTypes.READ_CONTENT_REQUEST:
    case ActionTypes.READ_CONTENTS_REQUEST:
      return true;
    case ActionTypes.READ_CONTENT_FAILURE:
    case ActionTypes.READ_CONTENTS_FAILURE:
    case ActionTypes.READ_CONTENT_SUCCESS:
    case ActionTypes.READ_CONTENTS_SUCCESS:
      return false;
    default:
      return state;
  }
};

const reducer = combineReducers({
  allIds,
  byId,
  updated,
  loading,
});

export default reducer;



// WEBPACK FOOTER //
// ./src/modules/content/content.reducer.js